<div class="icon">
  <cs-icon [name]="iconName"></cs-icon>
</div>
<div class="message">
  <ng-content></ng-content>
  @if (message) {
    {{ message }}
  }
</div>
